import { useT } from '@spotify-internal/i18n-core';
import React from 'react';
import styled from 'styled-components';
import { useReduxBlog } from './useReduxBlog';
import { ExternalLink } from './ExternalLink';
import {
  List,
  Text,
  TextLink,
  TypeListItem,
  black,
  cssSpacing,
} from '@spotify-internal/encore-web';
import { InteractiveElement } from '../../utils/InteractiveElement';

const Wrapper = styled.div`
  display: block;

  a {
    color: ${black} !important;
    text-decoration: none !important;

    &:hover,
    c &:focus,
    &:active {
      text-decoration: underline !important;
    }
  }
`;

const ListItem = styled(TypeListItem)`
  margin-top: ${cssSpacing('base')};
  margin-bottom: ${cssSpacing('base')};
`;

const TwitterSection = styled.section`
  h2 {
    margin-top: ${cssSpacing('base')};
    margin-bottom: ${cssSpacing('base')};
  }
  & p {
    margin: 0;
  }
`;

export const SideBar = ({ className }: { className?: string }) => {
  const { blogCategories, blogPosts } = useReduxBlog();
  const t = useT();
  return (
    <Wrapper className={className}>
      <Text as="h2">
        {t('FRODOR_dedbef', 'Recent', 'Most recently viewed pages')}
      </Text>
      <List>
        {blogCategories.bySlug.all.items
          .slice(0, 5)
          .map((id: string, index: number) => {
            const post = blogPosts!.byId[id];
            return (
              post && (
                <InteractiveElement
                  customComponent={TextLink}
                  href={`/blog/${post.urlSlug}`}
                  trackingLabel={`Recent Post #${index}`}
                  trackingCategory="Blog Category"
                >
                  <ListItem key={post.urlSlug} variant="titleSmall">
                    {post.title}
                  </ListItem>
                </InteractiveElement>
              )
            );
          })}
      </List>

      <TwitterSection>
        <Text as="h2" variant="bodyMedium">
          Twitter
        </Text>
        <p>{t('FRODOR_89ab3a', 'Keep up to date with Spotify Artist', '')}</p>
        <p>{t('FRODOR_12b4ba', 'News — Follow us on Twitter', '')}</p>
        <p>
          <ExternalLink
            href="https://twitter.com/spotifyartists"
            label={t('FRODOR_697cc1', 'Blog - Social - Twitter', '')}
          >
            @SpotifyArtists
          </ExternalLink>
        </p>
      </TwitterSection>
    </Wrapper>
  );
};
